import { ManufacturerRepository } from '../data/manufacturer-repository';

export class DeleteManufacturerUseCase {
  constructor(private readonly repository: ManufacturerRepository) {}

  async execute(id: number): Promise<void> {
    return this.repository.delete(id);
  }
}
